/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { CreateProposalJobResponse, CreateProposalJobVars } from '../openapi-types.gen.js';

export type { CreateProposalJobResponse, CreateProposalJobVars } from '../openapi-types.gen.js';

export const useCreateProposalJob = createMutationHook<CreateProposalJobVars, CreateProposalJobResponse, unknown>({
  specName: 'useCreateProposalJob',
  path: '/ai/proposal/jobs',
  method: 'POST',
  resolveUrl: (vars: CreateProposalJobVars) => `/ai/proposal/jobs`,
  buildBody: (vars: CreateProposalJobVars) => ({ prompt: vars.prompt }),
  parseResponse: (raw: unknown): CreateProposalJobResponse => raw as CreateProposalJobResponse,
  
  
  
});
